module.exports = __webpack_public_path__ + "img/tab-image2.3984d799.png";